
/**
 * Formata uma data como dd/mm/yyyy, considerando os dados UTC da mesma
 * @param {*} data Valor a ser formatado
 * @returns {String} Retorna a representação textual da data informada
 */
function formatarDataUTC(data) {
    //Caso seja um objeto Date
    if (data instanceof Date) {
        //Extrai os dados da data, formatando com zeros à esquerda
        const dia = data.getUTCDate().toString().padStart(2, '0');
        const mes = (data.getUTCMonth() + 1).toString().padStart(2, '0');
        const ano = data.getUTCFullYear().toString().padStart(4, '0');
        //Monta o retorno
        return `${dia}/${mes}/${ano}`;
    } else {
        //Retorna o próprio valor
        return data;
    }
}

/**
 * Formata uma data como mm/yyyy, considerando os dados UTC da mesma
 * @param {*} data Valor a ser formatado
 * @returns {String} Retorna a representação textual da data informada
 */
function formatarDataMes(data) {
    //Caso seja um objeto Date
    if (data instanceof Date) {
        //Extrai os dados da data, formatando com zeros à esquerda
        const mes = (data.getUTCMonth() + 1).toString().padStart(2, '0');
        const ano = data.getUTCFullYear().toString().padStart(4, '0');
        //Monta o retorno
        return `${mes}/${ano}`;
    } else {
        //Retorna o próprio valor
        return data;
    } 
}

export { formatarDataUTC, formatarDataMes };